import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import {
    isBrowser,
} from "react-device-detect";
import { getAuthorizedBranchIds } from "../utils/authHelper";
import AdmissionsLeadsDashboard from "../components/admissionForms/AdmissionsLeadsDashboard";
import AdmissionsTabHeader from "../components/admissionprocess/AdmissionsTabHeader";

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      globalBranches {
        id
        branch_name
        state_id
        district_id
        city_id
      }
    }
  }
`;

class AdmissionsDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");

        const globals = this.props.globals;
        const loading = globals.loading;
        const error = globals.error;

        if (error !== undefined) {
            alert("Server Error. " + error.message);
            return null;
        }

        let globalsData = globals.globals || { globalBranches: [] };

        if (
            Cookies.get("userlevel") != "1" &&
            Cookies.get("userlevel") != "2"
        ) {
            const authorizedIds = getAuthorizedBranchIds();

            let globalBranches = [];
            (globalsData.globalBranches || []).map((item) => {
                if (authorizedIds.includes(String(item.id))) {
                    globalBranches.push(item);
                }
            });
            globalsData.globalBranches = globalBranches;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div
                        id="sidebar"
                        className={
                            isBrowser === true
                                ? "sidebar-menu d-none d-xl-block d-lg-block"
                                : "sidebar-menu d-block d-xl-none d-lg-none"
                        }
                    >
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <AdmissionsTabHeader />
                        {loading ? (
                            <Container>
                                <Row className="my-2">
                                    <Col>
                                        <div className="spinner-border text-primary text-center loading-img-center"></div>
                                    </Col>
                                </Row>
                            </Container>
                        ) : (
                            <AdmissionsLeadsDashboard globals={globalsData} />
                        )}
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(
    compose(
        withApollo,
        graphql(FETCH_GLOBALS, {
            options: () => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                },
                fetchPolicy: "cache-and-network",
            }),
            name: "globals",
        })
    )(AdmissionsDashboard)
);
